/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — sci-club booking entry; forces an anonymous session
 *              and bootstraps it before the sci-club booking flow renders
 *   extends:   Route (@ember/routing/route)
 *   template:  none
 *   model:     none (returns undefined)
 *   key:       beforeModel (session.setAnonymous(true) + bootstrapSession),
 *              setupController (starts controller.loadDataTask, resets
 *              showMenu), resetController (cancels loadDataTask)
 *   uses:      services: session, controllerFor('application')
 *   siblings:  controllers/sciclub.js, templates/sciclub.hbs
 *
 * Route for the sci-club-specific booking vertical: same anonymous-session
 * bootstrap pattern as routes/user.js, delegating the actual data load to
 * SciclubController#loadDataTask.
 */
import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { inject as iService } from '@ember/service';

export default class SciClubRoute extends Route {
  @iService session;

  model() {}

  async beforeModel(transition) {
    await super.beforeModel(transition);
    const controller = this.controllerFor('application');
    this.session.setAnonymous(true);
    await this.session.bootstrapSession(transition, controller);
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.loadDataTask.perform();
    set(controller, 'showMenu', null);
  }

  resetController(controller) {
    controller.loadDataTask.cancelAll();
  }
}
